import { convertReviewRatingToNumber } from 'components/ProductReviewsPane/review.utils';
import { Product } from 'models/product';
import { Review } from 'models/review';

interface ProductStructuredReviewData {
  ['@context']: string;
  ['@type']: string;
  sku: string;
  name: string;
  image: string[];
  description: string;
  brand: {
    ['@type']: string;
    name: string;
  };
  review: {
    ['@type']: string;
    reviewRating: {
      ['@type']: string;
      ratingValue: number;
      bestRating: string;
    };
    author: {
      ['@type']: string;
      name: string;
    };
    name: string;
    reviewBody: string;
  }[];
  aggregateRating: {
    ['@type']: string;
    ratingValue: number;
    reviewCount: number;
    bestRating: string;
  };
  offers: {
    ['@type']: 'Offer';
    priceCurrency: string;
    price: string;
  };
}

export const getProductStructuredReviewData = (
  product: Product,
  reviews: Review[]
): ProductStructuredReviewData => ({
  '@context': 'https://schema.org/',
  '@type': 'Product',
  sku: product?.supplier_reference,
  name: product?.product_name,
  image: product?.media
    ?.filter((mediaItem) => mediaItem.type === 'IMAGE')
    .map((image) => image.url),
  description: product?.description,
  brand: {
    '@type': 'Brand',
    name: product?.supplier_name,
  },
  review: reviews?.slice(0, 3).map((review) => ({
    '@type': 'Review',
    reviewRating: {
      '@type': 'Rating',
      ratingValue: convertReviewRatingToNumber(review.rating),
      bestRating: '5',
    },
    author: {
      '@type': 'Person',
      name: review.guest_nickname,
    },
    name: review.title,
    reviewBody: review.body,
  })),
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: product?.review_rating,
    reviewCount: product?.review_count,
    bestRating: '5',
  },
  offers: {
    '@type': 'Offer',
    priceCurrency:
      product?.lowest_price_gross && product?.lowest_price_gross.length > 3
        ? product?.lowest_price_gross.substring(0, 3)
        : '',
    price:
      product?.lowest_price_gross && product?.lowest_price_gross.length > 3
        ? product?.lowest_price_gross.substring(3)
        : '',
  },
});
